import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'
import type { TMbaPowerschoolFeeCartLine } from '@/types/cart'

//Leave TMbaPowerschoolFeeData for reference purposes in case it needs to be used anywhere
export interface TMbaPowerschoolFeeData {
  feeId: string
  mbaPsFeeId: number
  menuItemId: number
  feeName: string
  feeDescription: string
  referenceId: number
  studentDcid: number
  assignedAmount: number
  amountDue: number
  amountPaid: number
  dateCreated: string
  feeTypeId: number | null
  schoolFeeId: number | null
  schoolId: number | null
  yearId: number | null
  formSubmissionId: string | null
  formData: string | null
  note: string | null
  partialPaymentEnabled: boolean
  isLunnch: boolean
}

export const mbaPowerschoolFees = async (studentAccountId: TStudentAccountId) => {
  const response = await new Request().get(
    '/ajax/student/' + studentAccountId + '/mba_powerschool_fees'
  )
  return Util.Obj.keysToCamel(response.data.items) as TMbaPowerschoolFeeCartLine[]
}
